var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "175 640 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M205.3,672.4V648c0-2.9-2.4-5.3-5.3-5.3s-5.3,2.4-5.3,5.3v24.4c-2,1.6-3.2,4-3.2,6.6c0,4.7,3.8,8.5,8.5,8.5 s8.5-3.8,8.5-8.5C208.5,676.4,207.3,674,205.3,672.4z M200.1,685c-3.3,0-6-2.7-6-6c0-2,1-3.8,2.6-4.9l0.6-0.4V648 c0-1.5,1.2-2.8,2.8-2.8c1.5,0,2.8,1.2,2.8,2.8v25.7l0.6,0.4c1.7,1.1,2.6,3,2.6,4.9C206,682.3,203.4,685,200.1,685z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M202.6,675.3l-1.2-0.8v-9.4v-5.6V658c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3v1.5v5.6v9.4l-1.2,0.8 c-1.2,0.8-2,2.2-2,3.7c0,2.5,2,4.5,4.5,4.5c2.5,0,4.5-2,4.5-4.5C204.6,677.5,203.8,676.1,202.6,675.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.d63c571ccb271baa58d0caa268a1fc28.svg";
export { ForwardRef as ReactComponent };